import { keyframes, Stack, styled } from "@mui/material";
import { matchPath, useLocation, useParams } from "react-router";
import { MeetingNotification } from "src/components";
import { Paths } from "src/constants";
import { OneOnOneMeetingNotificationDto, TeamMeetingNotificationDto, useGetActiveMeetingsForUser } from "src/http";

const MeetingNotificationsContainerAnimation = keyframes`
  0% { opacity: 0; transform: translateX(-50%) translateY(calc(100% + 20px)) }
  100% { opacity: 1; transform: translateX(-50%) translateY(0) }
`;

const MeetingNotificationsContainer = styled(Stack)`
  position: fixed;
  display: flex;
  left: 50%;
  bottom: 20px;
  opacity: 1;
  transform: translateX(-50%);
  z-index: 9999;
  animation: ${MeetingNotificationsContainerAnimation} 300ms ease-in-out;
`;

interface UrlParams {
  slug: string;
}

const MeetingNotificationSnackbar = () => {
  const { slug } = useParams<keyof UrlParams>() as UrlParams;
  const { data } = useGetActiveMeetingsForUser();
  const location = useLocation();

  // Don't show notifications while in a meeting
  if (matchPath(Paths.Meeting, location.pathname)) {
    return null;
  }

  if (data === undefined) {
    return null;
  }

  return (
    <MeetingNotificationsContainer spacing={0.5}>
      {(
        data.teamMeetings.filter((teamMeeting) => {
          if (!!matchPath(Paths.TeamMeetings, location.pathname)) {
            return teamMeeting.team.slug !== slug;
          } else {
            return true;
          }
        }) as (OneOnOneMeetingNotificationDto | TeamMeetingNotificationDto)[]
      )
        .concat(data.oneOnOneMeetings)
        .sort((a, b) => a.currentInstance!.startedAtDateTimeUtc.localeCompare(b.currentInstance!.startedAtDateTimeUtc))
        .map((meeting) => (
          <MeetingNotification meeting={meeting} />
        ))}
    </MeetingNotificationsContainer>
  );
};

export { MeetingNotificationSnackbar };
